import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { SHOPIFY_MOVE_SLICE_NAME } from "./shopifyMove.constants"

// Move errors carry no machine-readable code, only an English `detail` string —
// the global error notification (handleApiError) is the whole error UI.
export const moveShopifyStore = createAsyncThunk(
  `${SHOPIFY_MOVE_SLICE_NAME}/move_store`,
  async ({ shopify_store_id, business_id }, { dispatch, rejectWithValue }) => {
    const response = await services.moveShopifyStore({ shopify_store_id, business_id })

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)
